import { useEffect, useState } from "react";
import {
  collection,
  getDocs,
  addDoc,
  serverTimestamp,
} from "firebase/firestore";
import { QRCodeCanvas } from "qrcode.react";
import { db } from "../firebase";

const ADMIN_EMAIL = "shivsaini1794@gmail.com";

// ⭐ PAYMENT SETTINGS
const UPI_ID = "9602770371-2@ybl";


function Dashboard({
  user,
  isPremium,
  onStartTest,
  onStartMockTest,
  onOpenPDF,
  onOpenAdmin,
  onOpenHistory,
}) {
  const [mockTests, setMockTests] = useState([]);
  const [premiumPrice, setPremiumPrice] = useState(199);
  const UPI_LINK = `upi://pay?pa=${encodeURIComponent(UPI_ID)}&pn=${encodeURIComponent("SAINI LDCE MECHANICAL JE TEST")}&am=${premiumPrice}&cu=INR`;
  const [showPayment, setShowPayment] = useState(false);
  const [utr, setUtr] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
  const loadPremiumPrice = async () => {
    try {
      const snap = await getDocs(collection(db, "settings"));
      const item = snap.docs.find((d) => d.id === "payment");
      if (item?.data()?.premiumPrice) setPremiumPrice(item.data().premiumPrice);
    } catch (err) {
      console.error("Premium price load failed:", err);
    }
  };

    const loadTests = async () => {
      try {
        const snapshot = await getDocs(
          collection(db, "MockTests")
        );

        const counts = {};

        snapshot.docs.forEach((d) => {
          const t = d.data().test;

          if (t && t !== "free") {
            counts[t] = (counts[t] || 0) + 1;
          }
        });

        const tests = Object.entries(counts)
          .filter(
            ([testName, count]) =>
              /^mock\d+$/.test(testName) && count > 0
          )
          .sort(
            (a, b) =>
              parseInt(a[0].replace("mock", ""), 10) -
              parseInt(b[0].replace("mock", ""), 10)
          );

        setMockTests(tests);
      } catch (err) {
        console.error(err);
      }
    };

    loadTests();
    loadPremiumPrice();
  }, []);

  const logout = () => {
    window.location.reload();
  };

  const submitPaymentRequest = async () => {
    const cleanUtr = utr.trim();

    if (cleanUtr.length < 6) {
      alert("कृपया सही UTR / Transaction ID डालें");
      return;
    }

    try {
      setSubmitting(true);

      await addDoc(collection(db, "paymentRequests"), {
        userId: user.uid,
        userName: user.displayName || "User",
        userEmail: user.email || "",
        amount: Number(premiumPrice),
        upiId: UPI_ID,
        utr: cleanUtr,
        status: "pending",
        createdAt: serverTimestamp(),
      });

      alert(
        "✅ Payment Request Submitted\n\n" +
        "Admin payment verify करके Premium activate करेगा।"
      );

      setUtr("");
      setShowPayment(false);
    } catch (err) {
      console.error(err);
      alert("❌ Payment Request Failed");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      style={{
        maxWidth: "700px",
        margin: "30px auto",
        padding: "20px",
        borderRadius: "10px",
        background: "#fff",
      }}
    >
      <h2>👤 Dashboard</h2>

      <p>
        <b>{user.displayName}</b>
      </p>

      <p>{user.email}</p>

      <p>
        Membership :{" "}
        {isPremium ? "💎 Premium" : "🆓 Free"}
      </p>

      {!isPremium && (
        <>
          <button
            onClick={() => setShowPayment(true)}
            style={{
              width: "100%",
              padding: "14px",
              margin: "8px 0",
              fontSize: "16px",
              fontWeight: "bold",
            }}
          >
            💎 Buy Premium ₹{premiumPrice}
          </button>

          {showPayment && (
            <div
              style={{
                marginTop: "15px",
                padding: "20px",
                border: "2px solid #ddd",
                borderRadius: "10px",
                textAlign: "center",
              }}
            >
              <h2>💎 Premium Membership</h2>

              <h3>Amount: ₹{premiumPrice}</h3>

              <p>
                नीचे QR Scan करके ₹{premiumPrice} Pay करें
              </p>

              <QRCodeCanvas
                value={UPI_LINK}
                size={240}
                includeMargin={true}
              />

              <p>
                <b>UPI ID:</b>
                <br />
                {UPI_ID}
              </p>

              <a
                href={UPI_LINK}
                style={{
                  display: "inline-block",
                  padding: "12px 20px",
                  margin: "10px",
                  background: "#2196f3",
                  color: "white",
                  textDecoration: "none",
                  borderRadius: "6px",
                }}
              >
                📱 Open UPI App
              </a>

              <hr />

              <p>
                Payment करने के बाद अपना{" "}
                <b>UTR / Transaction ID</b> नीचे डालें:
              </p>

              <input
                type="text"
                value={utr}
                onChange={(e) => setUtr(e.target.value)}
                placeholder="UTR / Transaction ID"
                style={{
                  width: "90%",
                  padding: "12px",
                  margin: "8px 0",
                  fontSize: "16px",
                }}
              />

              <button
                onClick={submitPaymentRequest}
                disabled={submitting}
                style={{
                  width: "100%",
                  padding: "12px",
                  background: "green",
                  color: "white",
                  fontWeight: "bold",
                  marginTop: "8px",
                }}
              >
                {submitting
                  ? "Submitting..."
                  : "✅ Submit Payment"}
              </button>

              <button
                onClick={() => {
                  setShowPayment(false);
                  setUtr("");
                }}
                style={{
                  width: "100%",
                  padding: "10px",
                  marginTop: "8px",
                }}
              >
                ❌ Cancel
              </button>

              <p style={{ fontSize: "13px" }}>
                ⚠️ UPI PIN यहाँ कभी भी न डालें।
                केवल payment के बाद मिला UTR डालें।
              </p>
            </div>
          )}
        </>
      )}

      <hr />

      <h2>📝 Mock Tests</h2>

      <button
        style={{
          width: "100%",
          margin: "8px 0",
        }}
        onClick={onStartTest}
      >
        🆓 Free Mock Test
      </button>

      {mockTests.map(([testName, count]) => (
        <button
          key={testName}
          style={{
            width: "100%",
            margin: "8px 0",
          }}
          onClick={() => {
            if (!isPremium) {
              alert("🔒 Premium Required");
              return;
            }

            onStartMockTest(testName);
          }}
        >
          💎 Mock Test{" "}
          {testName.replace("mock", "")}{" "}
          ({Math.min(count, 100)} Questions)
        </button>
      ))}

      <hr />

      <h2>📊 Test History</h2>

      <button
        style={{
          width: "100%",
          margin: "8px 0",
        }}
        onClick={onOpenHistory}
      >
        📊 View Test History
      </button>

      <hr />

      <h2>📖 PDF Notes</h2>

      <button
        style={{
          width: "100%",
          margin: "8px 0",
        }}
        onClick={() => {
          if (!isPremium) {
            alert("🔒 Premium Membership Required");
            return;
          }

          onOpenPDF();
        }}
      >
        📖 Open PDF Notes
      </button>

      <hr />

      {user?.email === ADMIN_EMAIL && (
        <button
          style={{
            width: "100%",
            margin: "8px 0",
            background: "#222",
            color: "white",
          }}
          onClick={onOpenAdmin}
        >
          🛠 Admin Panel
        </button>
      )}

      <button
        style={{
          width: "100%",
          background: "red",
          color: "white",
          padding: "10px",
        }}
        onClick={logout}
      >
        Logout
      </button>
    </div>
  );
}

export default Dashboard;
